'use strict';

var firebase = require('firebase-legacy/app').default;
require('firebase-legacy/storage');
var KayleeBase = require('./KayleeBase');

function FirebaseStorage(pathStr, key, isWildcard) {
    if (typeof key === 'undefined') key = null;
    if (typeof isWildcard === 'undefined') isWildcard = false;
    this.pathStr = pathStr;
    this.dbRef = KayleeBase.app.database().ref(pathStr);

    // The Kaylee tester runs in a node environment where storage isn't
    // supported; so we need to test to see if the storage method exists
    // before calling it. Also, Jayne uses the firebase-admin package, which
    // complains that "KayleeBase.app.storage(...).ref is not a function"; so
    // we check for that and don't initialize storage in that case (this
    // resolves SNTY-1021).

    if (typeof KayleeBase.app.storage === 'function' &&
        typeof KayleeBase.app.storage().ref === 'function') {
        this.storageRef = KayleeBase.app.storage().ref(this.pathStr);
    }
    this.key = key;
    this.isWildcard = isWildcard;
}

FirebaseStorage.prototype.delete = function() {
    var self = this;
    return this.storageRef.delete()
    .then(function() {
        self.key = null;
    });
};

FirebaseStorage.prototype.getDownloadURL = function() {
    return this.storageRef.getDownloadURL();
};

FirebaseStorage.prototype.getMetadata = function() {
    return this.storageRef.getMetadata();
};

FirebaseStorage.prototype.put = function(data, metadata) {
    var uploadTask = this.storageRef.put(data, metadata);
    var self = this;

    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
        next: null,
        error: null,
        complete: function() {
            self.key = KayleeBase.getNewKey();
        }
    });

    return uploadTask;
};

FirebaseStorage.prototype.toString = function() {
    var refStr = this.storageRef ? this.storageRef.toString() : 'null';
    return '[Storage ' + refStr + ']';
};

FirebaseStorage.prototype.updateMetadata = function(metadata) {
    return this.ref.updateMetadata(metadata);
};

FirebaseStorage.prototype.updateKey = function(newKey) {
    this.key = newKey;
};

module.exports = FirebaseStorage;
